<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Nudge Templates Management
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Nudge Template</li>
        <li class="active">Nudge Templates List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Nudge Templates List</h3>
              <div class="action-button pull-right">
                <nv-select class="form-control turn-country-select" v-model="turnCountry" v-on:change="onTurnCountryChange()" title="Turn templates differ per country namespace">
                  <option v-for="country in countryList" :key="country" :value="country">{{country}}</option>
                </nv-select>
                <router-link class="btn btn-primary" :to="`create`">Add Nudge Template</router-link>
              </div>
            </div>

            <div class="box-footer no-border">
              <div class="row">
                <div class="col-md-12">
                  <vue-good-table
                    mode="remote"
                    styleClass="vgt-table good-table condensed striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :columns="columns"
                    :rows="nudgeTemplatesData"
                    :totalRows="nudgeTemplatesCount"
                    :pagination-options="{
                        enabled: true,
                        perPage: 20
                    }">
                    <div slot="emptystate"><nv-empty-state icon="fa-paper-plane" title="No templates found" hint="Try changing the filters, or add a new template." action-label="Add template" action-to="/nudge-template/create" /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />
                        <span v-if="props.column.field == 'edit'">
                          <router-link :to="`update?nudgeTemplateId=${props.row.id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else-if="props.column.field === 'createdAt'">
                          {{formatDate(props.row.createdAt, 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field === 'status'" class="ntm-status-chips">
                          <span v-for="(status, i) in statusList(props.row.status)" :key="i" class="ntm-status-chip" :class="statusChipClass(status)">{{ status }}</span>
                          <span v-for="category in categoryList(props.row.category)" :key="category" class="ntm-status-chip" :class="category === 'MARKETING' ? 'ntm-chip-marketing' : 'ntm-chip-unknown'">{{ category.toLowerCase() }}</span>
                        </span>
                        <span v-else-if="(props.column.field === 'delete' && props.row.template_languages)">
                          <i class="fa fa-times-circle" aria-hidden="true" v-on:click="showDeleteConfirmationPopup(props.row, props.index)"></i>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        
                      </template>    
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>    

    <deleteConfirmationModal
      v-if="isDeleteConfirmationVisible"        
      @close="closeConfirmationModal" 
      @deleteNudgeTemplate="deleteNudgeTemplate"
      :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
      :confirmationMessage="confirmationMessage" 
      :actionToBePerformed="actionToBePerformed"
      />

    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import api from '../../../utils/api'
import { getSelectorValue, formatDate } from '../../../utils/utilities'
import deleteConfirmationModal from './../popup/deleteConfirmation.vue'
export default {
  name: 'nudgeTemplatesList',
  components: {
    'deleteConfirmationModal': deleteConfirmationModal
  },
  data () {
    return {
      formatDate: formatDate,
      loading: true,
      nudgeTemplatesData: [],
      nudgeTemplatesCount: 0,
      isDeleteConfirmationVisible: false,
      actionToBePerformed: 'Delete Nudge Template',
      confirmationMessage: 'Are you sure you want to delete this nudge template?',
      rowIndexToBeUpdated: 0,
      tableQueryParams: {
        columnFilters: {},
        sort: {
          createdAt: 'desc'
        },
        page: 1,
        perPage: 20
      },
      previousQueryParams: {},
      countryList: [],
      turnCountry: '',
      columns: [
        {
          label: 'Template Title',
          field: 'template_title',
          tdClass: 'title',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Template Title'
          }
        },
        {
          label: 'Turn/English Content Preview',
          field: 'turn_text',
          sortable: false,
          tdClass: 'twenty-five-percent'
        },
        {
          label: 'Msgr/English Content Preview',
          field: 'msgr_text',
          sortable: false,
          tdClass: 'twenty-five-percent'
        },
        {
          label: 'Languages',
          field: 'template_languages',
          sortable: false,
          tdClass: 'ten-percent'
        },
        {
          label: 'Created On',
          field: 'createdAt',
          sortable: true,
          firstSortType: 'desc'
        },
        {
          label: 'Turn Status',
          field: 'status',
          sortable: false,
          tdClass: 'ten-percent'
        },
        {
          label: 'Edit',
          field: 'edit',
          sortable: false,
          tdClass: 'five-percent'
        },
        {
          label: 'Delete',
          field: 'delete',
          sortable: false,
          tdClass: 'five-percent'
        }
      ]
    }
  },
  computed: {
    isDeleteEnabled: function (props) {
      console.log('isDeleteEnabled::', (props.column.field === 'delete' && props.row.template_languages))
      console.log('props::', props)
      return (props.column.field === 'delete' && props.row.template_languages)
    }
  },
  async mounted () {
    await this.getTurnCountryList()
    this.getNudgeTemplatesList()
  },
  methods: {
    // "APPROVED, PENDING" (one per language) -> chips.
    statusList (status) {
      return String(status || 'NA').split(',').map(x => x.trim()).filter(Boolean)
    },
    categoryList (category) {
      return String(category || '').split(',').map(x => x.trim()).filter(Boolean)
    },
    statusChipClass (status) {
      if (status === 'APPROVED') return 'ntm-chip-approved'
      if (['REJECTED', 'PAUSED', 'DISABLED', 'DELETED', 'PENDING_DELETION', 'NOT_LISTED'].includes(status)) return 'ntm-chip-blocked'
      if (status === 'PENDING' || status === 'IN_APPEAL') return 'ntm-chip-pending'
      return 'ntm-chip-unknown'
    },
    async getTurnCountryList () {
      try {
        const response = await api.buildRequest('getQuickLinkConfig', 'POST')
        const whatsapp = (response.data.payload && response.data.payload.whatsapp) || {}
        this.countryList = Object.keys(whatsapp)
        if (!this.turnCountry && this.countryList.length) {
          this.turnCountry = this.countryList[0]
        }
      } catch (error) {
        console.error('Failed to fetch WhatsApp country list', error)
      }
    },
    onTurnCountryChange () {
      this.previousQueryParams = {}
      this.getNudgeTemplatesList()
    },
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.getNudgeTemplatesList()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.getNudgeTemplatesList()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType
        }
      })
      this.getNudgeTemplatesList()
    },
    onColumnFilter (params) {
      let appliedFilter = {}
      for (const key in params.columnFilters) {
        if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.getNudgeTemplatesList()
    },
    /**
     * @function getNudgeTemplatesList
     * @description Get offerings from database
     */
    async getNudgeTemplatesList () {
      this.loading = true

      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters),
        country: this.turnCountry
      }

      if (JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams)) {
        this.loading = false
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }
      api.buildRequest('getNudgeTemplates', 'GET', queryParams)
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.previousQueryParams = queryParams
              this.nudgeTemplatesData = response.data.payload.nudgeTemplatesList
              this.nudgeTemplatesCount = response.data.payload.nudgeTemplatesCount
            } else {
              this.$swal({
                type: 'error',
                text: 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    showDeleteConfirmationPopup (nudgeTemplateData, index) {
      this.isDeleteConfirmationVisible = true
      this.confirmationMessage = `Are you sure you want to delete ${nudgeTemplateData.template_title} nudge template?`
      this.rowIndexToBeUpdated = index
    },
    /**
     * @function closeConfirmationModal
     * @description Function to close delete confirmation popup
     */
    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
    },
    /**
     * @description Delete Nudge Template mapping in db
     */
    deleteNudgeTemplate () {
      this.loading = true
      const deletedRowData = this.nudgeTemplatesData[this.rowIndexToBeUpdated]
      this.nudgeTemplatesData.splice(this.rowIndexToBeUpdated, 1)
      this.closeConfirmationModal()
      const params = { id: deletedRowData.id }
      var self = this
      api.buildRequest('deleteNudgeTemplate', 'DELETE', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            if (response.status === 200) {
              self.getNudgeTemplatesList().then(() => this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Nudge Template deleted successfully'
              }))
            } else {
              console.log('something went wrong')
            }
          }).catch((error) => {
            console.log(error)
            self.rowIndexToBeUpdated = 0
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: error ? error.data.payload.message : 'An error occurred'
            })
          })
    }
  }
}
</script>
<style>
.ntm-status-chips { display: inline-flex; flex-wrap: wrap; gap: 4px; }
.ntm-status-chip { font-size: 11px; padding: 1px 7px; border-radius: 10px; white-space: nowrap; }
.ntm-chip-approved { background: #ecfdf3; color: #027a48; }
.ntm-chip-blocked { background: #fef3f2; color: #b42318; }
.ntm-chip-pending { background: #fffaeb; color: #b54708; }
.ntm-chip-unknown { background: #f2f4f7; color: #475467; }
.ntm-chip-marketing { background: #f4f3ff; color: #5925dc; }
.title {
  overflow-wrap: anywhere;
  width: 20%;
}
.ten-percent {
  width: 10%;
}
.twenty-five-percent {
  width: 25%;
}
.five-percent {
  width: 5%;
}
.vgt-inner-wrap.is-loading {
  opacity: 1 !important;
  pointer-events: auto !important;
}
.mrgn-right-20px {
  margin-right: 20px;
}
.good-table td {
  white-space: normal;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
.vgt-left-align {
  padding-left: 16px !important;
  text-align: center;
  vertical-align: middle!important;
}
.vgt-input {
  text-align: center;

}
.turn-country-select {
  display: inline-block;
  min-width: 180px;
  margin-right: 10px;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// nudgeTemplateList.vue?d66ac86e